import { Box, Text } from '@chakra-ui/react'
import { useTranslation } from 'react-i18next'
import {
  DialogBackdrop,
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogHeader,
  DialogRoot,
} from '../../ui/dialog'
import { colors } from '../../../utilities/colors'

const CARPOOL_HEADER_OFFSET = 80

export default function VehicleTrackingModal({ isOpen, onClose, trackingUrl, vehicle }) {
  const { t } = useTranslation()

  const vehicleLabel = vehicle
    ? `${vehicle.year ?? ''} ${vehicle.make ?? ''} ${vehicle.model ?? ''}`.replace(/\s+/g, ' ').trim()
    : ''
  const title = vehicleLabel || t('Track Vehicle')

  return (
    <DialogRoot open={isOpen} onOpenChange={onClose} size="xl" placement="center" scrollBehavior="inside">
      <DialogBackdrop />
      <DialogContent maxW="1100px" w="95vw" h="90vh">
        <DialogHeader
          color={colors.green}
          fontSize="md"
          fontWeight="semibold"
          bg={colors.deepOcean}
          borderTopRadius="md"
          pr={10}
        >
          <Text
            as="span"
            display="block"
            whiteSpace="nowrap"
            overflow="hidden"
            textOverflow="ellipsis"
            lineHeight="1.6"
          >
            {title}
          </Text>
        </DialogHeader>
        <DialogCloseTrigger aria-label="Close tracking" top="5" />
        <DialogBody bg={colors.deepOcean} px={0} pt={6} pb={0} display="flex" flex="1" minH={0} borderBottomRadius="md">
          {trackingUrl && (
            <Box w="full" h="full" overflow="hidden" borderBottomRadius="md">
              <Box
                as="iframe"
                src={trackingUrl}
                title={title}
                w="full"
                h={`calc(100% + ${CARPOOL_HEADER_OFFSET}px)`}
                mt={`-${CARPOOL_HEADER_OFFSET}px`}
                border="none"
                referrerPolicy="no-referrer"
                sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
              />
            </Box>
          )}
        </DialogBody>
      </DialogContent>
    </DialogRoot>
  )
}
